import { SanityFooterSocialLink } from '@data/sanity/queries/types/site'

interface FooterSocialProps {
  links: SanityFooterSocialLink[]
}

const FooterSocial = ({ links }: FooterSocialProps) => (
  <div className="flex flex-wrap mb-4 mt-2">
    {links.map((link) => (
      <a
        key={link._key}
        id={`footer-social-link-${link.socialNetwork?.toLowerCase()}`}
        href={link.url}
        target="_blank"
        rel="noopener noreferrer"
        className="mr-5 last:mr-0"
      >
        {link.socialNetwork}
      </a>
    ))}
  </div>
)

export default FooterSocial
